<div class="elements">
  <div (click)="addToGroup(element)" *ngFor="let element of elements" class="item group-element">
    <span class="item__label">{{element.name}}</span>
  </div>
</div>
